// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"228":"5efd1c3c","306":"b4ca513d","398":"13b9ed86","399":"b1ad0666","639":"67fa8700","690":"b2e96ff9"}[chunkId] + ".chunk.css";
};